import {
  checkReportingAccessRoutine,
  triggerReportingReportRoutine,
  getReportingReportRoutine,
  getReportingReportsRoutine,
  pollReportingReportRoutine,
  stopPollingReportingRoutine,
  clearReportingRoutine,
  updateReportingAnswerRoutine,
  regenerateReportingAnswerRoutine,
  cloneReportingReportRoutine,
  exportReportingPdfRoutine,
  exportReportingWordRoutine,
  exportReportingCsvRoutine,
  updateReportingParticularsRoutine
} from './actions'
import emptyReportingState from './state'

export default (state = emptyReportingState, action) => {
  switch (action.type) {
    // Check Access
    case checkReportingAccessRoutine.REQUEST:
      return {
        ...state,
        isLoadingAccess: true,
        accessError: null
      }
    case checkReportingAccessRoutine.SUCCESS:
      return {
        ...state,
        access: action.payload,
        accessError: null
      }
    case checkReportingAccessRoutine.FAILURE:
      return {
        ...state,
        accessError: action.payload
      }
    case checkReportingAccessRoutine.FULFILL:
      return {
        ...state,
        isLoadingAccess: false
      }

    // Trigger Report
    case triggerReportingReportRoutine.REQUEST:
      return {
        ...state,
        isTriggering: true,
        triggerError: null
      }
    case triggerReportingReportRoutine.SUCCESS:
      return {
        ...state,
        currentReport: action.payload,
        triggerError: null
      }
    case triggerReportingReportRoutine.FAILURE:
      return {
        ...state,
        triggerError: action.payload
      }
    case triggerReportingReportRoutine.FULFILL:
      return {
        ...state,
        isTriggering: false
      }

    // Get Single Report
    case getReportingReportRoutine.REQUEST:
      return {
        ...state,
        isLoadingReport: true,
        reportError: null
      }
    case getReportingReportRoutine.SUCCESS:
      return {
        ...state,
        currentReport: action.payload,
        reportError: null
      }
    case getReportingReportRoutine.FAILURE:
      return {
        ...state,
        reportError: action.payload
      }
    case getReportingReportRoutine.FULFILL:
      return {
        ...state,
        isLoadingReport: false
      }

    // Get Reports List
    case getReportingReportsRoutine.REQUEST:
      return {
        ...state,
        isLoadingReports: true,
        reportsError: null
      }
    case getReportingReportsRoutine.SUCCESS:
      return {
        ...state,
        reports: action.payload.reports,
        reportsMeta: action.payload.meta,
        reportsError: null
      }
    case getReportingReportsRoutine.FAILURE:
      return {
        ...state,
        reportsError: action.payload
      }
    case getReportingReportsRoutine.FULFILL:
      return {
        ...state,
        isLoadingReports: false
      }

    // Poll Report
    case pollReportingReportRoutine.REQUEST:
      return {
        ...state,
        isPolling: true
      }
    case pollReportingReportRoutine.SUCCESS:
      return {
        ...state,
        currentReport: action.payload,
        isPolling: false
      }
    case pollReportingReportRoutine.FAILURE:
      return {
        ...state,
        reportError: action.payload,
        isPolling: false
      }
    case pollReportingReportRoutine.FULFILL:
      return {
        ...state,
        isPolling: false
      }

    // Stop Polling
    case stopPollingReportingRoutine.SUCCESS:
      return {
        ...state,
        isPolling: false
      }

    // Clear - preserves access state so menu item stays visible
    case clearReportingRoutine.TRIGGER:
      return {
        ...emptyReportingState,
        // Preserve access state to avoid menu flicker
        access: state.access,
        isLoadingAccess: state.isLoadingAccess,
        accessError: state.accessError
      }

    // Update Answer
    case updateReportingAnswerRoutine.REQUEST:
      return {
        ...state,
        isUpdatingAnswer: true,
        editingQuestionId: action.payload?.questionId || null,
        updateAnswerError: null
      }
    case updateReportingAnswerRoutine.SUCCESS:
      return {
        ...state,
        currentReport: action.payload,
        editingQuestionId: null,
        updateAnswerError: null
      }
    case updateReportingAnswerRoutine.FAILURE:
      return {
        ...state,
        updateAnswerError: action.payload
      }
    case updateReportingAnswerRoutine.FULFILL:
      return {
        ...state,
        isUpdatingAnswer: false
      }

    // Update Particulars
    case updateReportingParticularsRoutine.REQUEST:
      return {
        ...state,
        isUpdatingParticulars: true,
        particularsError: null
      }
    case updateReportingParticularsRoutine.SUCCESS:
      return {
        ...state,
        currentReport: state.currentReport
          ? { ...state.currentReport, particulars: action.payload.particulars }
          : state.currentReport,
        particularsError: null
      }
    case updateReportingParticularsRoutine.FAILURE:
      return {
        ...state,
        particularsError: action.payload
      }
    case updateReportingParticularsRoutine.FULFILL:
      return {
        ...state,
        isUpdatingParticulars: false
      }

    // Regenerate Answer
    case regenerateReportingAnswerRoutine.REQUEST:
      return {
        ...state,
        isRegeneratingAnswer: true,
        regeneratingQuestionId: action.payload?.questionId || null,
        regenerateAnswerError: null
      }
    case regenerateReportingAnswerRoutine.SUCCESS:
      return {
        ...state,
        currentReport: action.payload,
        regeneratingQuestionId: null,
        regenerateAnswerError: null
      }
    case regenerateReportingAnswerRoutine.FAILURE:
      return {
        ...state,
        regenerateAnswerError: action.payload
      }
    case regenerateReportingAnswerRoutine.FULFILL:
      return {
        ...state,
        isRegeneratingAnswer: false,
        regeneratingQuestionId: null
      }

    // Clone Report
    case cloneReportingReportRoutine.REQUEST:
      return {
        ...state,
        isCloning: true,
        cloneError: null
      }
    case cloneReportingReportRoutine.SUCCESS:
      return {
        ...state,
        currentReport: action.payload,
        cloneError: null
      }
    case cloneReportingReportRoutine.FAILURE:
      return {
        ...state,
        cloneError: action.payload
      }
    case cloneReportingReportRoutine.FULFILL:
      return {
        ...state,
        isCloning: false
      }

    // Export PDF
    case exportReportingPdfRoutine.REQUEST:
      return {
        ...state,
        isExportingPdf: true,
        exportPdfError: null
      }
    case exportReportingPdfRoutine.SUCCESS:
      return {
        ...state,
        exportPdfError: null
      }
    case exportReportingPdfRoutine.FAILURE:
      return {
        ...state,
        exportPdfError: action.payload
      }
    case exportReportingPdfRoutine.FULFILL:
      return {
        ...state,
        isExportingPdf: false
      }

    // Export Word
    case exportReportingWordRoutine.REQUEST:
      return {
        ...state,
        isExportingWord: true,
        exportWordError: null
      }
    case exportReportingWordRoutine.SUCCESS:
      return {
        ...state,
        exportWordError: null
      }
    case exportReportingWordRoutine.FAILURE:
      return {
        ...state,
        exportWordError: action.payload
      }
    case exportReportingWordRoutine.FULFILL:
      return {
        ...state,
        isExportingWord: false
      }

    // Export CSV
    case exportReportingCsvRoutine.REQUEST:
      return {
        ...state,
        isExportingCsv: true,
        exportCsvError: null
      }
    case exportReportingCsvRoutine.SUCCESS:
      return {
        ...state,
        exportCsvError: null
      }
    case exportReportingCsvRoutine.FAILURE:
      return {
        ...state,
        exportCsvError: action.payload
      }
    case exportReportingCsvRoutine.FULFILL:
      return {
        ...state,
        isExportingCsv: false
      }

    default:
      return state
  }
}
